function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"autoprefixer\":false,\"sourceMap\":true,\"minimize\":true}!../../../../node_modules/poi/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-394397ca\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=styles&index=0!./GeolocationNavbar.vue")
}
var normalizeComponent = require("!../../../../node_modules/poi/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"presets\":[[\"/home/runner/work/clube/clube/node_modules/babel-preset-poi/index.js\",{\"jsx\":\"vue\"}]],\"cacheDirectory\":true}!../../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=script&index=0!./GeolocationNavbar.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"presets\":[[\"/home/runner/work/clube/clube/node_modules/babel-preset-poi/index.js\",{\"jsx\":\"vue\"}]],\"cacheDirectory\":true}!../../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=script&index=0!./GeolocationNavbar.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/poi/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-394397ca\",\"hasScoped\":true,\"transformToRequire\":{\"img\":\"src\",\"image\":\"xlink:href\",\"cimage\":\"placeholder\",\"c-image\":\"placeholder\",\"CImage\":\"placeholder\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/poi/node_modules/vue-loader/lib/selector?type=template&index=0!./GeolocationNavbar.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-394397ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Navbar/GeolocationNavbar.vue
// module id = 2088
// module chunks = 1612